/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import { ListGroupItem, Button, Badge } from 'reactstrap';
import { Col, Row } from 'antd';

export default function ListView({ files }) {
  const renderItem = (item) => {
    return (
      <ListGroupItem key={item.id} className='px-2'>
        <Row gutter={[12, 12]}>
          <Col flex='none'>
            <i className='avatar rounded-circle ni ni-folder-17 bg-primary' style={{ fontSize: 16 }} />
          </Col>
          <Col flex='auto'>
            <h4 className='mb-0'>
              <span onClick={() => window.open(item.downloadUrl)} style={{ cursor: 'pointer' }}>
                {item.title}
              </span>
            </h4>
            <small>{item.subTitle}</small>
          </Col>
          <Col flex='none'>
            <Badge color='secondary'>{item.fileType}</Badge>
          </Col>
          <Col flex='none'>
            <div className='d-flex'>
              <a href={item.downloadUrl} target='_blank' rel='noreferrer' className='mr-2'>
                <Button color='primary' className='btn-icon btn-3' size='sm'>
                  <span className='btn-inner--icon'>
                    <i className='ni ni-cloud-download-95' />
                  </span>
                  <span className='btn-inner--text'>Tải về</span>
                </Button>
              </a>
            </div>
          </Col>
        </Row>
      </ListGroupItem>
    );
  };

  return (
    <div>
      {files.map((item) => {
        return renderItem(item);
      })}
    </div>
  );
}
